import { render, staticRenderFns } from "./GoalDetailList.vue?vue&type=template&id=787b7913&scoped=true"
import script from "./GoalDetailList.vue?vue&type=script&lang=js"
export * from "./GoalDetailList.vue?vue&type=script&lang=js"
import style0 from "./GoalDetailList.vue?vue&type=style&index=0&id=787b7913&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b7913",
  null
  
)

export default component.exports